import React from "react";
import Navbar from "../../components/navbar/Navbar";
import { Box } from "@mui/material";
import Footer from "../../components/Footer/Footer";
import OT from "../../components/our_team/OurTeam";
import "./OurTeam.css";

const OurTeam = () => {
  return (
    <Box>
      <Navbar />
      <OT />
      <Footer />
    </Box>
  );
};

export default OurTeam;